export default __webpack_public_path__ + "static/media/bunnybutt.25a067c1.svg";